import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  BadRequestHandler,
  GlobalMessageService,
  GlobalMessageType,
  HttpResponseStatus,
  RoutingService
} from '@spartacus/core';

const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';

@Injectable({
  providedIn: 'root',
})
export class CustomBadRequestHandler extends BadRequestHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handleBadPassword(request, response);
    this.handleBadLoginResponse(request, response);
    this.handleValidationError(request, response);
    this.handleVoucherOperationError(request, response);
    this.handleGuestDuplicateEmail(request, response);
    this.handleUnknownIdentifierError(request, response);
    this.handleTokenInvalidatedError(request, response);
    this.handleVoucherOperationAlreadyExistsError(request, response);
  }

  constructor(
    protected globalMessageService: GlobalMessageService,
    @Inject(PLATFORM_ID) protected platformId?,
    protected routingService?: RoutingService,
  ) {
    super(globalMessageService);
  }

  protected handleUnknownIdentifierError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => e.type === 'UnknownIdentifierError')
      .forEach((error) => {
        if (!error?.message.includes('Product with code') && !error?.message.includes('Category with code')) {
          this.globalMessageService.add(
            error.message
              ? error.message
              : { key: 'httpHandlers.unknownIdentifier' },
            GlobalMessageType.MSG_TYPE_ERROR
          );
        }
      });
  }

  protected handleVoucherOperationError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse,
  ): void {
    const messages = {
      'coupon.already.exists.cart': 'httpHandlers.couponAlreadyExistsCart',
      'coupon.not.active.expired': 'httpHandlers.couponExpired',
      'coupon.already.redeemed': 'httpHandlers.couponAlreadyRedeemedCart',
      'coupon.invalid.code.provided': 'httpHandlers.invalidCodeProvided',
    };
    this.getErrors(response)
      .filter(
        (e) =>
          !!messages[e.message] && e.type === 'VoucherOperationError',
      )
      .forEach((e) => {
        if (!!messages[e.message]) {
          this.globalMessageService.add(
            { key: messages[e.message] },
            GlobalMessageType.MSG_TYPE_ERROR,
          );
        } else {
          this.globalMessageService.add(
            { key: 'httpHandlers.invalidCodeProvided' },
            GlobalMessageType.MSG_TYPE_ERROR,
          );
        }
      });
  }

  protected handleTokenInvalidatedError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => e.type === 'TokenInvalidatedError')
      .forEach((error) => {
        this.globalMessageService.add(
          error.message
            ? error.message
            : { key: 'httpHandlers.tokenInvalidated' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }

  protected handleVoucherOperationAlreadyExistsError(
    _request: HttpRequest<any>,
    response: HttpErrorResponse
  ): void {
    this.getErrors(response)
      .filter((e) => e.type === 'VoucherOperationAlreadyExistsError')
      .forEach((error) => {
        this.globalMessageService.add(
          { key: 'httpHandlers.couponAlreadyExistsCart' },
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
  }
}
